import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledImg = styled('img')`
  && {
    max-height: 60px;
    max-width: 60px;
  }
`;

const ChildrenImage = ({ rowData }) => (
  <div>
    {rowData.images.small !== '' && <StyledImg src={rowData.images.small} />}
    {rowData.images.small == '' && <StyledImg src='https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Circle-icons-profile.svg/1024px-Circle-icons-profile.svg.png' />}
  </div>
);

ChildrenImage.propTypes = {
  rowData: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default ChildrenImage;
